import { component } from 'picoapp'

export default component((node, ctx) => {
  const $collection = $('#collection');
  const $genderToggle = $('.js-toggle-gender');
  const $genderContent = $('.js-gender-content');
  const $prodLinks = $('.js-prod-link');
  const $bannerExpandButton = $('.js-banner-expand-button');
  const $bannerCollapseButton = $('.js-banner-collapse-button');
  const $bannerExtraContent = $('.js-banner-extra-content');
  const $bannerMainContent = $('.js-banner-main-content');
  
  $genderToggle.click(function() {
    const gender = $(this).attr('data-gender');
    const collectionHandle = $(this).attr('data-collection-handle');
    const collectionTitle = $(this).attr('data-collection');
    const activeCollection = $collection.attr('data-active-collection');
    
    //Set collection title
    $('.js-coll-title').text(collectionTitle);
    
    //Filter gender content
    $genderContent.each(function() {
      $(this).attr('data-content-gender', gender);
    });
    
    //Update product links
    $prodLinks.each(function() {
      let href = $(this).attr('href');
      href = href.replace(activeCollection, collectionHandle);
      $(this).attr('href', href);
    });
    
    //Set active collection 
    $collection.attr('data-active-collection', collectionHandle);
  });

  $bannerExpandButton.click(function(e) {
    e.preventDefault();

    const $banner = $(this).parents('.js-scroll-banner');

    $banner.addClass('collection__banner--expand');
    $bannerMainContent.addClass('collection__banner__content--hide');
    $bannerExtraContent.addClass('active');

    $bannerCollapseButton.addClass('active');
  });

  $bannerCollapseButton.click(function(e) {
    e.preventDefault();

    const $banner = $(this).parents('.js-scroll-banner');

    $bannerExtraContent.removeClass('active');
    $banner.removeClass('collection__banner--expand');
    $bannerMainContent.removeClass('collection__banner__content--hide');
    $bannerCollapseButton.removeClass('active');
  });
  
});

export function plpNavbar () {
  const $navbar = $('.js-navbar');
  const $collectionNavDesktop = $('.js-collection-nav');
  const $collectionNavMobile = $('.js-collection-nav-main');
  
  if ($collectionNavDesktop.length) {
    let $activeNavItem = false;
    let $activeProduct = false;
    let scrollTimeout;
    
    const $groupLinks = $('.js-group-link');
    
    $(window).scroll(function() {
      if (!scrollTimeout) {
       scrollTimeout = setTimeout(function () {
         setActiveNavItem();
         scrollTimeout = null;
       }, 300);
     }
    });
    
    function setActiveNavItem() {
      let activeProduct = false;
      
      let collectionNavBottom = $collectionNavMobile.offset().top + $collectionNavMobile.outerHeight();
      
      if (matchMedia('screen and (max-width: 767px)').matches) {
        collectionNavBottom = collectionNavBottom + 25;
      }
      else {
        collectionNavBottom = collectionNavBottom + 50;
      }
      
      let targetTop = $('.js-product-group').offset().top;
      let targetBottom = $('.js-product-group').offset().top + $('.js-product-group').outerHeight();
      
      $groupLinks.each(function() {
        let $target = $($(this).attr('href'));
        
        if ($target.length) {
          
          let targetTop = $target.offset().top;
          let targetBottom = $target.offset().top + $target.outerHeight();
        
          if (collectionNavBottom > targetTop && collectionNavBottom < targetBottom) {
            if (!activeProduct) {
              $activeNavItem = $(this).closest('li');
              
              if (!$activeNavItem.hasClass('active')) {
                
                $('.js-group-link').closest('li').removeClass('active');
                $activeNavItem.addClass('active');
                
                //Animate scroll nav PLP 
                if (matchMedia('screen and (max-width: 767px)').matches) {
                  let offset = 0;
                  $('.js-collection-nav-main li').each(function() {
                    if ($(this).hasClass('active')) {
                      return false;
                    }
                    else {
                      offset = offset + $(this).outerWidth(true);
                    }
                  });
                  $collectionNavMobile.find('ul').animate({scrollLeft: offset - 20}, 200);
                  
                  if ($activeNavItem.is(':last-child')) {
                    $collectionNavMobile.addClass('scroll-end');
                  }
                  else {
                    $collectionNavMobile.removeClass('scroll-end');
                  }
                }
              }
              
              activeProduct = true;
            }
            return false;
          }
          else {
            activeProduct = false;
          }
        }
      });
    }
    
    $groupLinks.click(function(e) {
      e.preventDefault();
      
      let margin = 20;
      let collectionNavHeight = $collectionNavDesktop.outerHeight();
      let $target = $($(this).attr('href'));
      
      if ($target.length) {
        let targetPos = $target.offset().top;
        let scrollDown = targetPos > $(window).scrollTop() ? true : false;
        
        let scrollTo = targetPos - $navbar.height() - collectionNavHeight - margin;
        
        if (matchMedia('screen and (max-width: 767px)').matches) {
          
          collectionNavHeight = $collectionNavMobile.outerHeight();
          scrollTo = targetPos - collectionNavHeight - margin;
          
          if ($('.js-navbar').hasClass('visible')) {
            scrollTo = scrollTo - $('.js-navbar').outerHeight();
            if (scrollDown) {
              scrollTo = scrollTo + $('.js-navbar').outerHeight();
            }
          }
        }
        
        $('html, body').stop().animate({
          scrollTop: scrollTo,
        }, 250);
      }
    });
  }
}